import { SizeChartForm } from "../../+merchant/+size-chart-name/manage-size-chart-name/manage-size-chart-name.utils"
import { BaseDto } from "./base.dto"
import { FileDto } from "./file.dto"
import { PagingDto } from "./paging.dto"

export class FindSizeChartDto extends PagingDto {
  searchText?: string
}

export class SizeChartDto extends BaseDto {
  type: string
  image: FileDto
  data: any[]
  content: string
  contentKh: string
}

export class CreateSizeChartNameDto {
  sizeChartId: string
  name: string
  // title?: string
  // titleKh?: string
  data: SizeChartForm
}

export class SizeChartNameDto extends BaseDto {
  values: SizeChartValueDto[]
  title: string
  titleKh: string
  enabled: boolean
  sortOrder: number
  name: string
  sizeChartId: string
  data: any
  sizeChart: SizeChartDto
  hasKeyUpdate: boolean

  static create() {
    return new SizeChartNameDto()
  }
}

export class SizeChartValueDto {
  value: string
  valueKh: string

  static create() {
    return new SizeChartValueDto()
  }
}

export class SizeChartNameValue {
  type: string
  keys: string[] = []
  values: string[][] = []
  keysKh: string[] = []
  valuesKh: string[][] = []

  static create() {
    return new SizeChartNameValue()
  }
}